import React from 'react'
import { Avatar, Button } from '@deal/components'
import classnames from 'classnames'
import styles from './styles.css'
import { BusinessUserState } from '#src/generated/types'
import { useReplaceDeactivatedExpertMutation } from './replaceDeactivatedExpert.generated'
import { MessageBubbleRawText } from '@deal/chat-firebase'
interface DeactivatedExpertChatBannerProps {
  conversationId: string
  expertName: string
  consumerName: string
  expertState: BusinessUserState
  placeHolderExpertProfilePhotoUrl: string | undefined | null
  placeHolderExpertName: string | undefined | null
}

const DeactivatedExpertChatBanner: React.FC<DeactivatedExpertChatBannerProps> = ({
  conversationId,
  expertName,
  expertState,
  consumerName,
  placeHolderExpertProfilePhotoUrl,
  placeHolderExpertName
}) => {
  const [replaceDeactivatedExpert] = useReplaceDeactivatedExpertMutation({
    variables: { conversationId: conversationId },
    // have to use the query name string instead of query document.   if we use query document, we need to supply the variables, which we don't have.
    // by providing query name, apollo is going to refetch based on the current/last variables.
    refetchQueries: [
      'GetConversationByCategoryId',
      'GetConversationByConsumerAndCategoryId',
      'GetConversationByConsumerAndCategoryId',
      'GetConversationByDepartmentSlug',
      'GetConversationByCategoryId'
    ]
  })

  if (true || expertState !== BusinessUserState.DEACTIVATED) {
    return null
  }
  return (
    <div className={styles.messageList}>
      <div className={styles.notAvailable}>{expertName} is no longer available</div>
      <div className={classnames(styles.group, styles.flat)}>
        <div className={styles.columns}>
          <Avatar
            name={placeHolderExpertName || 'Curated'}
            className={styles.avatar}
            src={placeHolderExpertProfilePhotoUrl || undefined}
          />
          <MessageBubbleRawText className={styles.message}>
            <span className={classnames(styles.sender)}>Curated</span>
            <div className={styles.messageText}>
              <div>Welcome back {consumerName}!</div>
              <div>Want advice? Need help comparing options? Just have a question?</div>
              <div>Click below to connect with an available expert.</div>
            </div>
            <div className={styles.connectMeButtonRow}>
              <div className={styles.connectMeButtonBox}>
                <Button
                  onClick={() => replaceDeactivatedExpert()}
                  className={styles.connectMeButton}
                >
                  Connect now
                </Button>
              </div>
            </div>
          </MessageBubbleRawText>
        </div>
      </div>
    </div>
  )
}

export default DeactivatedExpertChatBanner
